<div>
    <div class="content" *ngIf="detailsData?.length >= 1">
        <div class="d-container d-md-flex align-items-center mb-4">
            @for(detail of detailsData; track $index){
                <div class="div finance py-2 px-1">
                    <p>{{ detail.split('|')[0] }}</p>
                    <p class="sm-bold mt-1">{{ detail.split('|')[1] }}</p>
                </div>
            }
        </div>
    </div>
    <div class="content1 align-items-center">
        <p [innerHTML]="detailsDescription | safeHtml"></p>
</div>